import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['programSelect', 'companySelect'];
  static values = { companyLocked: Boolean };

  connect() {
    if (this.companyLockedValue) return;
    if (this.hasProgramSelectTarget && this.programSelectTarget.value) {
      this.loadCompanies({ target: this.programSelectTarget });
    }
  }

  resetCompanies({ placeholder }) {
    const select = this.companySelectTarget;
    select.innerHTML = '';
    const opt = new Option(placeholder, '', true, true);
    opt.disabled = true;
    select.appendChild(opt);
    select.disabled = true;
  }

  loadCompanies(event) {
    if (this.companyLockedValue) return;

    const programId = event.target.value;
    const select = this.companySelectTarget;

    if (!programId) {
      this.resetCompanies({ placeholder: 'Select a program first' });
      return;
    }

    select.disabled = false;
    select.innerHTML = '';
    select.appendChild(new Option('Loading…', '', true, true));

    fetch(`/rbf_data_changes/organizations_by_program?program_id=${programId}`)
      .then((res) => res.json())
      .then((orgs) => {
        select.innerHTML = '';
        if (!orgs.length) {
          this.resetCompanies({ placeholder: 'No companies available' });
          return;
        }
        orgs.forEach(({ id, name }, index) => {
          select.appendChild(new Option(name, id, index === 0, index === 0));
        });
      })
      .catch(() => {
        this.resetCompanies({ placeholder: 'Failed to load companies' });
      });
  }
}
